module.exports = __webpack_public_path__ + "static/img/img-kang-riki.cd22212.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing_page/img-kang-riki.png
// module id = ckc7
// module chunks = 36